import { Box } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { numberWithComma } from "../utils/functions";
import { BetContext } from "../context/context";



export default function BetButton({odds,size,onClick=()=>{},side,customClass = "",isFancy=false,market_type}){
    const [ sizeChanged,setSizeChanged ] = useState(false);
    const [ oddsChanged,setOddschanged ] = useState(false);
    const [disabled,setDisabled] = useState(false);
    const [prevOdds,setPrevOdds] = useState(0);
    const {setUpdateBetslip} = useContext(BetContext);

    useEffect(()=>{
        setSizeChanged(true);
        setTimeout(()=>{
            setSizeChanged(false);
        },300)
    },[size])

    useEffect(()=>{
        setOddschanged(true);
        setTimeout(()=>{
            setOddschanged(false);
            setPrevOdds(odds);
        },300)
        if(!odds) setDisabled(true);
        else {
            if(market_type === "match_odd" && odds >= 11) setDisabled(true);
            else setDisabled(false)
        };
    },[odds,market_type])


    const handleClick = () =>{
        if(!disabled) 
        {
            onClick() 
            setUpdateBetslip(prev=>!prev)
        }
    }

    return(
        <Box onClick={handleClick} className={`${customClass} bet-button ${disabled && "disabled"} ${side} ${sizeChanged && "size-highlighted"} ${oddsChanged ? prevOdds > odds ? "price-down-highlighted": "price-up-highlighted" : ""}`}>
            <Box class="price">{odds?odds:""}</Box>
            {
                size > 0
                &&
                <Box class="market-volume">{isFancy?size:(Number(size) < 5000) ? numberWithComma(Number(size.toFixed(2))*100):"500,000+"}</Box>
            }
        </Box>
    )
}